<template>
  <div class="auth-page">
    <div class="auth-card">
      <div class="auth-brand">
        <div class="auth-brand__icon"><i class="bi bi-envelope-check"></i></div>
        <div>
          <div class="auth-brand__title">Почти готово!</div>
          <div class="auth-brand__subtitle">Остался один шаг — подтвердите email</div>
        </div>
      </div>

      <div class="auth-body">
        <p class="auth-body__text">
          Мы отправили письмо со ссылкой для подтверждения
          <template v-if="email"> на <span class="auth-body__email">{{ email }}</span></template>.
          Откройте его и перейдите по ссылке, чтобы активировать аккаунт и сразу войти в систему.
        </p>

        <div class="auth-hint">
          <i class="bi bi-info-circle me-2"></i>
          Не нашли письмо? Проверьте папку «Спам» — иногда оно попадает туда.
        </div>

        <router-link class="btn btn-primary w-100 mt-3" to="/login">
          Перейти ко входу
        </router-link>

        <div class="auth-footer">
          <router-link to="/">На главную</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const email = computed(() => String(route.query.email || '').trim())
</script>

<style scoped>
.auth-page {
  min-height: calc(100vh - 102px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background:
    radial-gradient(circle at 18% 15%, rgba(16, 185, 129, 0.12), transparent 40%),
    radial-gradient(circle at 82% 82%, rgba(13, 110, 253, 0.11), transparent 45%),
    #f7f9fd;
}

.auth-card {
  width: 100%;
  max-width: 480px;
  background: #fff;
  border: 1px solid #e8edf7;
  border-radius: 16px;
  box-shadow: 0 16px 40px rgba(17, 24, 39, 0.12);
  overflow: hidden;
}

.auth-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px 20px;
  color: #fff;
  background: linear-gradient(135deg, #0f766e, #10b981);
}

.auth-brand__icon {
  flex: 0 0 auto;
  width: 44px;
  height: 44px;
  border-radius: 13px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  background: rgba(255, 255, 255, 0.16);
}

.auth-brand__title {
  font-size: 20px;
  font-weight: 700;
  line-height: 1.2;
}

.auth-brand__subtitle {
  margin-top: 4px;
  font-size: 13px;
  opacity: 0.92;
}

.auth-body {
  padding: 18px 20px 20px;
}

.auth-body__text {
  color: #3c4a63;
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 14px;
}

.auth-body__email {
  font-weight: 700;
  color: #0f766e;
  white-space: nowrap;
}

.auth-hint {
  background: #f1f8f5;
  border: 1px solid #d6ebe1;
  border-radius: 12px;
  color: #3f6f5e;
  font-size: 13px;
  padding: 10px 12px;
}

.auth-footer {
  margin-top: 14px;
  font-size: 13px;
  color: #5f6f8b;
  text-align: center;
}

.auth-footer a {
  color: #1d5ed8;
  text-decoration: none;
  font-weight: 600;
}

.auth-footer a:hover {
  text-decoration: underline;
}
</style>
